import { ActionDialog } from '@/components/shared/components/ActionDialog';
import { Text } from '@/components/shared/components/Text';

export const CartItemDialogConfirmationDialog = ({ opened, setter, onConfirm }) => {
  return (
    <ActionDialog
      Title={<Text tId="CART_DIALOG_CANCEL_CONFIRM" />}
      Description={<Text tId="CART_DIALOG_CANCEL_CONFIRM_TEXT" />}
      MainButton={<Text tId={'CLOSE'} />}
      onSubmit={onConfirm}
      opened={opened}
      setOpened={setter}
      handleClose={() => setter(false)}
    />
  );
};
